module.exports = __webpack_public_path__ + "img/lightbulb-slash.499b2095.svg";